import queryString from 'query-string';
import * as C from '../constants';
import { getPath } from '../utils/helpers';
import * as yaml from 'js-yaml';

export function storeData(payload: any, type: string) {
  return {
    payload,
    type,
  };
}

export function clearData(type: string, payload = null) {
  return {
    type,
    payload,
  };
}

export function storeError(payload: string) {
  return {
    type: C.STORE_ERROR,
    payload,
  };
}

export function closeError() {
  return {
    type: C.CLOSE_ERROR,
  };
}

const getSortData = (data) => {
  const yamlText = data?.content?.texts;
  const textsArray = yamlText && yaml.load(yamlText);

  const textsObj = {};
  textsArray.forEach(({ uid, key }) => {
    textsObj[uid] = key;
  });

  const { error, home, ...paint } = data?.pages;

  const paintData = [];
  Object.keys(paint).forEach((paintmKey, index) => {
    const currentData = paint[paintmKey];

    const icon = currentData?.images?.[1]?.url;

    const colors = currentData.pages.map((item) => {
      const yamlColors = item.content.colors;
      const colorsArray = yamlColors && yaml.load(yamlColors);
      const sub = colorsArray.map((colorItem) => colorItem.color);

      return {
        colorid: item.content.colorid,
        default: item.content.defaultcolor,
        visible: true,
        sub,
      };
    });

    const currentPaintData = {
      name: currentData.content.title,
      id: index + 1,
      colors,
      icon,
    };

    paintData.push(currentPaintData);
  });

  const config = {
    propeller: data?.content?.propeller === 'true',
    sky: data?.content?.sky === 'true',
    winglight: data?.content?.winglight === 'true',
    rotation: data?.content?.rotation === 'true',
  };

  const updatedData = {
    labels: {
      title: data.content.title,
      ...textsObj,
    },
    paint: paintData,
    config,
  };

  return updatedData;
};

const getJSON = async (lng) => {
  // const parsed: any = queryString.parse(window.location.search);
  const API = 'API_LIMIT'; // parsed?.limit === 'true' ? 'API_LIMIT' : 'API';
  const random = Date.now() + Math.floor(Math.random() * 10000);
  const staticPath = `./assets/${API}.json?nocache=${random}`;

  const urlPrefix = getPath();
  const dynamicPath = `${urlPrefix}/${lng}/api`;
  const path = process.env.NODE_ENV !== 'production' ? dynamicPath : staticPath;

  const response = await fetch(path);
  const api = await response.json();

  return api[lng];
};

export function fetchData(type) {
  return async (dispatch, getState) => {
    const lng = getState().app.lng;
    const data = await getJSON(lng);
    const sortData = getSortData(data);

    return dispatch(storeData(sortData, type));
  };
}
